import { z } from 'zod';
import {
  AkCertPemInputSchema,
  BaseResponseSchema,
  EkCertPemInputSchema,
} from './primitives.js';

// ========================================
// Manufacturing API — Edge Device Pre-load
// ========================================

export const MfgDeviceRowSchema = z.object({
  ekCertPem: EkCertPemInputSchema,
  akCertPem: AkCertPemInputSchema.pipe(z.string().min(10)),
  manufacturerName: z.string().min(1).max(255).optional(),
  deviceCategory: z.enum(['efem-gateway', 'location-gateway']),
  model: z.string().min(1).max(128),
  mfgBatch: z.string().min(1).max(64),
  mfgDate: z.string().refine(
    (s) => /^\d{4}-\d{2}-\d{2}$/.test(s as string) || /^(1[0-2]|0?[1-9])\/(3[01]|[12][0-9]|0?[1-9])\/\d{4}$/.test(s as string),
    { message: 'mfgDate must be YYYY-MM-DD or M/D/YYYY' },
  ),
});



export const MfgBatchDeviceOutcomeSchema = z.object({
  serialNumber: z.string().min(1),
  outcome: z.enum(['registered', 'skipped']),
});



export const RegisterBatchResponseSchema = BaseResponseSchema.extend({
  data: z.object({
    registered: z.number().int().min(0),
    skipped: z.number().int().min(0),
    errors: z.array(z.string()),
    /** Per-row outcomes with assigned Cnapse serials (for CM label printing). */
    devices: z.array(MfgBatchDeviceOutcomeSchema),
  }),
});
// Inferred types
export type MfgBatchDeviceOutcome = z.infer<typeof MfgBatchDeviceOutcomeSchema>;
export type MfgDeviceRow = z.infer<typeof MfgDeviceRowSchema>;
export type RegisterBatchResponse = z.infer<typeof RegisterBatchResponseSchema>;
